import DOMPurify from 'dompurify';

/**
 * The formatting the copy actually uses. Taken from what the translations and the survey and consent payloads
 * contain: headings, paragraphs, lists, emphasis, line breaks and links.
 */
const ALLOWED_TAGS = [
    'a',
    'b',
    'br',
    'div',
    'em',
    'h3',
    'h4',
    'h5',
    'h6',
    'i',
    'li',
    'ol',
    'p',
    'span',
    'strong',
    'u',
    'ul',
];

/**
 * Nothing else, which is the point: an event-handler attribute is what makes injected markup dangerous, and no copy
 * needs one. DOMPurify rejects javascript: and data: URIs on href by itself.
 */
const ALLOWED_ATTR = ['href', 'target', 'rel', 'title'];

/**
 * Cleans HTML that did not come from this repo before it is handed to `dangerouslySetInnerHTML`.
 *
 * React will not run a `<script>` inserted that way, but it will happily run an event-handler attribute such as
 * `onerror` on an injected `<img>`, so markup written outside the frontend needs cleaning first. This applies to KYC
 * question info text (know-your-customer-service) and consent copy (consent-service): both are authored as service
 * data rather than as code, and neither is sanitized anywhere along the way -- consumerloan-application-service binds
 * it to a typed record and the proxy passes the survey response through as raw bytes.
 *
 * Re-serializing also repairs malformed markup, which this content genuinely contains: the v4 NO PEP explainer opens
 * with an unbalanced closing tag.
 */
export const sanitizeHtml = (html: string): string =>
    DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR, ALLOW_DATA_ATTR: false });
